import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { CardComponent } from '@vectronic/ui';
import pkg from '../../../package.json';

@Component({
  selector: 'my-vectronic-about',
  templateUrl: './about-my-vectronic.component.html',
  styleUrls: ['./about-my-vectronic.component.scss'],
  imports: [CardComponent, MatDialogModule],
})
export class AboutMyVectronicComponent {
  data: undefined;
  myVectronicVersion: string = pkg?.version;
}
